import { Navbar, Footer } from '../components/Balsuite';

const sections = [
  {
    title: '1. What Are Cookies?',
    content: `Cookies are small text files stored on your device when you visit a website. They help websites remember information about your visit, such as your preferred language and other settings, which can make your next visit easier and the site more useful to you.`,
  },
  {
    title: '2. How We Use Cookies',
    content: `Balsuite uses cookies to keep you signed in, remember your preferences, understand how you use our platform, and improve our services. We use both session cookies (which expire when you close your browser) and persistent cookies (which stay on your device until they expire or you delete them).`,
  },
  {
    title: '3. Types of Cookies We Use',
    content: `Essential cookies — These are required for the platform to work. They enable core functionality such as authentication, session management, and security. You cannot opt out of these.\n\nAnalytics cookies — These help us understand how visitors interact with Balsuite by collecting and reporting information anonymously. We use this data to improve performance and usability.\n\nPreference cookies — These cookies remember your settings and preferences (e.g., language, theme) so you don't have to reconfigure them on every visit.\n\nMarketing cookies — With your consent, we may use these to show you relevant promotional content on third-party platforms.`,
  },
  {
    title: '4. Third-Party Cookies',
    content: `We use trusted third-party services that may also set cookies on your device, including analytics providers and payment processors. These third parties have their own privacy and cookie policies, which we encourage you to review.`,
  },
  {
    title: '5. Managing Cookies',
    content: `You can control and manage cookies through your browser settings. Most browsers allow you to refuse cookies, delete existing cookies, or notify you before a cookie is stored.\n\nPlease note that disabling certain cookies may affect the functionality of Balsuite. Essential cookies cannot be disabled without impacting your ability to use the platform.`,
  },
  {
    title: '6. Updates to This Policy',
    content: `We may update this Cookie Policy as our practices change or as required by law. We will notify you of any significant changes by posting a notice on our website. Your continued use of Balsuite after such changes constitutes acceptance of the updated policy.`,
  },
  {
    title: '7. Contact Us',
    content: `If you have questions about our use of cookies, please contact us at:\n\nEmail: contact@balvirt.com\nWebsite: https://balvirt.com`,
  },
];

export default function CookiePolicyPage() {
  const lastUpdated = new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <div className="balsuite-page">
      <Navbar />
      <main style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 2rem 3rem' }}>
        <div style={{ marginBottom: '3rem' }}>
          <span className="sec-label">Legal</span>
          <h1 className="sec-h2" style={{ marginTop: '0.5rem' }}>Cookie Policy</h1>
          <p style={{ color: 'var(--t3)', fontSize: '0.875rem', marginTop: '0.5rem' }}>Last updated: {lastUpdated}</p>
          <p className="sec-sub" style={{ marginTop: '1rem', maxWidth: '600px' }}>
            This policy explains how Balsuite uses cookies and similar technologies when you visit our
            platform, and how you can manage your cookie preferences.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
          {sections.map(s => (
            <div key={s.title} style={{ borderLeft: '3px solid rgba(99,102,241,0.3)', paddingLeft: '1.5rem' }}>
              <h2 style={{ fontFamily: 'Bricolage Grotesque, sans-serif', fontWeight: 700, fontSize: '1.05rem', color: 'var(--t1)', marginBottom: '0.75rem' }}>
                {s.title}
              </h2>
              <div style={{ fontSize: '0.9rem', color: 'var(--t2)', lineHeight: '1.85', whiteSpace: 'pre-line' }}>
                {s.content}
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: '3rem', padding: '1.5rem', background: 'var(--bg2)', borderRadius: '12px', fontSize: '0.875rem', color: 'var(--t2)' }}>
          Also see our{' '}
          <a href="/privacy" style={{ color: 'var(--primary)', fontWeight: 600 }}>Privacy Policy</a>
          {' '}and{' '}
          <a href="/termconditions" style={{ color: 'var(--primary)', fontWeight: 600 }}>Terms of Service</a>.
        </div>
      </main>
      <Footer />
    </div>
  );
}
